export enum FlightListScope {
	All = 'all',
	Departures = 'departures',
	Arrivals = 'arrivals',
}
